module.exports = __webpack_public_path__ + "static/media/jaipur.40859045.jpg";